import { Toaster as SonnerToaster } from 'sonner';

export const Toaster = () => {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: 'var(--card)',
          border: '1px solid var(--muted)',
          color: 'var(--fg)',
        },
        className: 'font-sans',
      }}
      data-testid="global-toaster"
    />
  );
};